<!-- 
  /** 
  * @author Mau de Pallares 
  * @company Erillam Healthcare 
  * @version 2.0 
  */ -->
<template>
  <div>
    <v-data-table :headers="headers" :items="list" :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles" dense fixed-header hide-default-footer>
      <template v-slot:[`item.registrationDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.registrationDate) }}
      </template>
     
      <template v-slot:[`item.status`]="{ item }">
        <v-chip class="mt-1 mb-1" :color="$cnst.statusNameStudies.find((status) => {
          return status.status === item.status;
        }).color
          ">
          {{
            $cnst.statusNameStudies.find((status) => {
              return status.status === item.status;
            }).name
          }}
        </v-chip>
      </template>
      <template v-slot:[`item.fullNameReferringPhysician`]="{ item }">
        {{ $utilFront.nonEmpty(item.fullNameReferringPhysician) ? item.fullNameReferringPhysician : 'A quien corresponda.'}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "HistoryStudiesTable",
  props: {
    list: Array,
    itemsPerPage: Number,
  },
  data() {
    return {
      headers: [
        {
          text: "Id paciente",
          value: "patient.idPatient",
          sortable: false,
          align: "center",
        },
        {
          text: "Paciente",
          value: "patient.person.fullName",
          align: "center",
          sortable: false,
        },
        {
          text: "Id estudio",
          value: "idStudy",
          sortable: false,
          align: "center",
        },
        {
          text: "Modalidad",
          value: "modality.fullName",
          sortable: false,
          align: "center",
        },
        {
          text: "Perfil de estudio",
          value: "studyModality.fullName",
          sortable: false,
          align: "center",
        },
        {
          text: "Estatus",
          value: "status",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha de estudios",
          value: "registrationDate",
          sortable: false,
          align: "center",
        },
        {
          text: "Médico referido",
          value: "fullNameReferringPhysician",
          sortable: false,
          align: "center",
        },
      ],
    };
  },
  methods: {},
};
</script>
